export default __webpack_public_path__ + "905ae7345f75f1dfd7c1b6f9eef4d8ba.svg";